import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { ClinicStudiesSearchQuery, ClinicStudiesSearchQueryVariables } from '@/shared/api';
import CLINIC_STUDIES_QUERY from '../queries/clinicStudiesSearch';

/**
 * Loads a filtered page of clinic studies for the support screens. Runs the same CLINIC_STUDIES_QUERY with filter and limit and throws the first GraphQL error message when clinicStudies is nil.
 *
 * @param filter - Filter criteria forwarded to the GraphQL query.
 * @param limit - Maximum number of records to return, defaulting to 10.
 * @returns The clinic studies page.
 */
const fetchClinicStudiesSupport = async (
  filter: ClinicStudiesSearchQueryVariables['filter'],
  limit = 10,
): Promise<ClinicStudiesSearchQuery['clinicStudies']> => {
  const client = createClient();
  const clinicStudiesResult = await client.query<
    ClinicStudiesSearchQuery,
    ClinicStudiesSearchQueryVariables
  >({
    query: CLINIC_STUDIES_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { data, errors } = clinicStudiesResult;
  const { clinicStudies } = data;
  if (_.isNil(clinicStudies) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return clinicStudies;
};

export default fetchClinicStudiesSupport;
